/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Search/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'



/** @type {import('Simple/types.js').View} */
export default function Search({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/Filters/Search",
  onChange
  
}) {
let tabSelectedFiltersSearchTermValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.filters.search_term',
})
let tabSelectedFiltersSearchTermChangeData = fromData.useDataChange({ viewPath,
context: 'tab',
path: 'selected.filters.search_term',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="tab.selected.filters.search_term"
 value={tabSelectedFiltersSearchTermValueData}
 onChange={tabSelectedFiltersSearchTermChangeData}
 size="small"
 marginTop={0}
 maxWidth={200}
 placeholder="Search"
>
{childProps => (
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
)}
</TysiaInput>
{children}
</React.Fragment>)
}